import { render, staticRenderFns } from "./BasePlanSwitcher.vue?vue&type=template&id=25f5de8f&"
import script from "./BasePlanSwitcher.vue?vue&type=script&lang=js&"
export * from "./BasePlanSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports